import React from "react";
import { Link } from "react-router-dom";
import LoginBg from "./../images/login-bg.jpg";
import NotFoundImg from "./../images/404.svg";

const NotFound = () => {

    return (
        <div className="login-wrap min-vh-100 min-vw-100 d-flex align-items-center" style={{ backgroundImage: `url(${LoginBg})`}}>
             <div className="container">
                 <div className="row justify-content-center">
                     <div className="col-12 col-lg-7">
                         <div className="not-found-wrap rounded-3" style={{backgroundColor: "#f3f2f2"}}>
                            <div className="404-img ps-5 pe-2 pt-2 pb-5">
                                <img src={NotFoundImg} alt="Page not found" className="w-100 d-block mx-auto" style={{maxWidth: "500px"}} />
                            </div>
                            <div className="404-content pb-4 px-4 text-center">
                                <h2 className="text-uppercase">Sorry, Sidan kunde inte hittas</h2>
                                <p>The link you followed probably broken or the page has been removed.</p>
                            </div>
                            <div className="404-btns pb-4 text-center">
                                <Link to="/" className="btn btn-halite-blue rounded-pill me-2 mb-3 mb-lg-0" style={{width: "200px"}}>
                                    <i className="fa fa-caret-right" aria-hidden="true"></i>
                                    <span className="ms-2">Return to home</span>
                                </Link>
                                <Link to="/contact/" className="btn btn-halite-blue rounded-pill" style={{width: "200px"}}>
                                    <i className="fa fa-caret-right" aria-hidden="true"></i>
                                    <span className="ms-2">Kontakta oss</span>
                                </Link>
                            </div>
                         </div>
                     </div>
                 </div>
             </div>
        </div>
    );
}

export default NotFound;